var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "#F28F14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.926 5C5.862 5 5 5.829 5 6.852v16.296C5 24.171 5.862 25 6.926 25h28.148C36.138 25 37 24.171 37 23.148V6.852C37 5.829 36.138 5 35.074 5H6.926zm18.602 5.587c0 .715-.274 1.37-.73 1.878.287-.081.59-.125.904-.125 1.721 0 3.116 1.308 3.116 2.921 0 1.615-1.395 2.923-3.116 2.923-.454 0-.886-.091-1.275-.255.343.47.544 1.038.544 1.65 0 1.614-1.395 2.922-3.116 2.922-1.722 0-3.117-1.308-3.117-2.922 0-.062.002-.123.006-.184a3.19 3.19 0 01-2.445 1.11c-1.72 0-3.116-1.308-3.116-2.922 0-1.376 1.014-2.53 2.38-2.84-1.217-.398-2.09-1.483-2.09-2.76 0-1.614 1.395-2.922 3.116-2.922 1.158 0 2.169.593 2.706 1.472.03-1.589 1.414-2.868 3.116-2.868 1.722 0 3.117 1.308 3.117 2.922zm-6.75 4.469c0-.962.833-1.743 1.858-1.743 1.026 0 1.86.782 1.86 1.743 0 .96-.834 1.742-1.86 1.742-1.025 0-1.859-.782-1.859-1.742z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 19a1 1 0 01-1-1V3a3 3 0 013-3h18a1 1 0 110 2H3a1 1 0 00-1 1v15a1 1 0 01-1 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubPhoto);
export default __webpack_public_path__ + "static/media/club-photo.0001dbfd596891ce14e767c3d5858c7e.svg";
export { ForwardRef as ReactComponent };